// =============================================================================
// SIREPPAR - Catálogo de localidades de Chubut
// =============================================================================
// Única fuente del listado de localidades para TODA la app. Sale de la tabla
// `localidades` del backend, que trae para cada una su sección (= departamento).
//
// Antes cada pantalla tenía su propio array hardcodeado de 36 localidades, y las
// cuatro copias no coincidían entre sí ni con la base: nombres con y sin acento,
// "Dique Ameghino" donde la base dice "DIQUE FLORENTINO AMEGHINO", y dos entradas
// que no son localidades ("Alto Río Senguer", "Piedra Parada"). De ahí venía buena
// parte de la basura acumulada en las columnas de localidad y departamento.
//
// Si hay que agregar o corregir una localidad: se toca la tabla (scripts/
// seed-localidades.js) y todas las pantallas quedan al día solas.
//
// El endpoint es público porque los wizards de /reempadronamiento y /constitucion
// son pantallas sin sesión. El catálogo se cachea: es estático.
// =============================================================================

import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

export interface Localidad {
  id: number;
  nombre: string;
  /** Sección electoral, que es lo que el sistema llama departamento. */
  seccion: string;
}

export function useLocalidades() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['catalogo-localidades'],
    queryFn: async () => (await api.get('/padrones/localidades')).data.data as Localidad[],
    staleTime: Infinity, // catálogo estático: no hace falta revalidarlo
    gcTime: Infinity,
  });

  const localidades = data ?? [];

  /** Sección (departamento) de una localidad por nombre. '' si no está. */
  const seccionDe = (nombre?: string | null): string =>
    localidades.find((l) => l.nombre === nombre)?.seccion ?? '';

  return { localidades, seccionDe, isLoading, isError };
}
